import { PropsWithChildren } from "react";
import { VendedorInternoModal } from "src/components/projetos/containers/VendedorInternoModal";
import { useObservable } from "src/framework/store/storeUtil";
import { vendedorInternoModalIsOpenedStore$ } from "src/store/vendas/projetos/store";
import { VendedorInternoModalStoreType } from "src/store/vendas/projetos/types";

interface DefaultLayoutProps extends PropsWithChildren<{}> {}

export default function DefaultLayout({ children }: DefaultLayoutProps) {
  const vendedorModalStore = useObservable<VendedorInternoModalStoreType>(vendedorInternoModalIsOpenedStore$)
  
  return (
    <>
      {children}
      {vendedorModalStore?.status && <VendedorInternoModal /> }
    </>
  )
}